import { Component, Input, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { ConfirmationService } from "primeng/api";
import { DialogService } from "primeng/dynamicdialog";
import { DataService_TopicMaintenance } from "../shared/data.service";
import { PanicAlertPersonAssignComponent } from "./panic-alert-person-assign/panic-alert-person-assign.component";
import { PanicAlertTopicRequest } from "../shared/panic-alert-topic-request";

@Component({
	selector: "caass-panic-alert-person-table",
	templateUrl: "./panic-alert-person-table.component.html",
	styleUrls: ["./panic-alert-person-table.component.css"],
})
export class PanicAlertPersonTableComponent implements OnInit, OnChanges {
	constructor(private dataService: DataService_TopicMaintenance, private dialogService: DialogService, private confirmationService: ConfirmationService) {}

	ngOnInit(): void {
		this.UpdateData();
		this.loadTable();
	}

	ngOnChanges(changes: SimpleChanges): void {
		this.UpdateData();
		this.loadTable();
	}

	///////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////

	@Input() SelectedPortalPanicAlertTopic: any;

	TopicCD: string = "";

	pagerows: number = 10;
	pagefirst: number = 0;

	SelectedPortalPanicAlertTopicPersons: any = [];
	lstPortalPanicAlertTopicPerson: any = [];

	ShowInfo: boolean = false;

	TableLoading: boolean = false;
	Processing: boolean = false;
	errorMessage: string = "";

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Load Data
	///////////////////////////////////////////////////////////////

	UpdateData() {
		this.TopicCD = "";

		if (this.SelectedPortalPanicAlertTopic != undefined && this.SelectedPortalPanicAlertTopic.TopicCD != undefined) {
			this.TopicCD = this.SelectedPortalPanicAlertTopic.TopicCD;
		}
	}

	loadTable() {
		this.lstPortalPanicAlertTopicPerson = [];
		this.SelectedPortalPanicAlertTopicPersons = [];

		if (this.SelectedPortalPanicAlertTopic == undefined || this.SelectedPortalPanicAlertTopic.PortalPanicAlertTopicID == undefined) {
			return;
		}

		this.TableLoading = true;

		var result = this.dataService.PanicAlertTopicPersonSelectList(this.SelectedPortalPanicAlertTopic.PortalPanicAlertTopicID);
		result.subscribe(
			(response) => {
				this.lstPortalPanicAlertTopicPerson = response;

				this.TableLoading = false;
			},
			(error) => {
				this.TableLoading = false;
			}
		);
	}

	///////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////

	onRefresh() {
		this.loadTable();
	}

	onAssign() {
		this.errorMessage = "";

		if (this.SelectedPortalPanicAlertTopic == undefined) {
			this.errorMessage = "Select a Topic to assign people to";
			return;
		}

		var ref = this.dialogService.open(PanicAlertPersonAssignComponent, {
			header: "Assign Staff",
			width: "fit-content",
			data: {
				SelectedPortalPanicAlertTopic: this.SelectedPortalPanicAlertTopic,
			},
		});
		ref.onClose.subscribe((response) => {
			if (response == 1) {
				this.loadTable();
			}
		});
	}

	onUnassign() {
		this.errorMessage = "";

		if (this.SelectedPortalPanicAlertTopic == undefined) {
			this.errorMessage = "Select a Topic to unassign people";
			return;
		}

		if (this.SelectedPortalPanicAlertTopicPersons.length == 0) {
			this.errorMessage = "Select people to remove from this topic";
			return;
		}

		var Msg: string = "Are you sure you want to unassign " + this.SelectedPortalPanicAlertTopicPersons.length;
		Msg += " staff member" + (this.SelectedPortalPanicAlertTopicPersons.length == 1 ? "" : "s");
		Msg += ' from the topic "' + this.TopicCD + '"?';

		this.confirmationService.confirm({
			key: "panicalerttopicpersonconfirm",
			acceptLabel: "Yes",
			rejectLabel: "No",
			rejectVisible: true,
			message: Msg,
			header: "Confirm Unassign",
			icon: "fa",
			accept: () => {
				this.onFinishUnassign();
			},
		});
	}

	onFinishUnassign() {
		var lstPIDs: number[] = [];
		lstPIDs = this.SelectedPortalPanicAlertTopicPersons.map((item: any) => item.PersonID);

		var parms: PanicAlertTopicRequest = {
			PortalPanicAlertTopicID: this.SelectedPortalPanicAlertTopic.PortalPanicAlertTopicID,
			SchoolID: -1,
			TopicCD: "",
			TopicDesc: "",
			lstPersonID: lstPIDs,
		};

		this.Processing = true;

		var result = this.dataService.PanicAlertTopicUnassign(parms);
		result.subscribe(
			(response: any) => {
				if (response.Success == true) {
					//Success Dialog
					this.confirmationService.confirm({
						key: "panicalerttopicperson",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Staff memebers were unassigned successfully.",
						header: "Success",
						icon: "fa",
						accept: () => {
							this.loadTable();
						},
					});
				} else {
					//Fail Dialog
					this.confirmationService.confirm({
						key: "panicalerttopicperson",
						acceptLabel: "Ok",
						rejectVisible: false,
						message: "Could Not Unassign Staff: " + response.ErrorMessage,
						header: "ERROR",
						icon: "fa",
						accept: () => {},
					});
				}

				this.Processing = false;
			},
			(error) => {
				this.Processing = false;
			}
		);
	}

	onShowInfo() {
		this.ShowInfo = !this.ShowInfo;
	}

	///////////////////////////////////////////////////////////////

	IsLoading() {
		return this.TableLoading == true || this.Processing == true;
	}
}
